/**
 * 模組名稱：MainFrame
 * 模組說明 : 前端主框架
 * @module MainFrame
 */

// ----- import from npm modules -----
import {Navigate, Route, Routes} from 'react-router-dom';

// ----- import from base components -----
import {BaseComponent, connect, PropTypes, React} from '../../components/BaseComponent';

// ----- import from local components -----
import DispatchCalendarContainer from 'web/modules/dispatch-calendar';
import DispatchManagementContainer from 'web/modules/dispatch-management';
import EmployeeContainer from 'web/modules/employee';
import MachineContainer from 'web/modules/machine';
import MachineAssignmentContainer from 'web/modules/machine-assignment';
import SatisfactionManagementContainer from 'web/modules/satisfaction-management';
import SatisfactionSurveyContainer from 'web/modules/satisfaction-survey';
import SatisfactionSurveyDetailContainer from 'web/modules/satisfaction-survey-detail';
import enumList from 'web/utils/enumList';
import AccountManagementContainer from '../../modules/account-management';
import AppearanceManagementContainer from '../../modules/appearance-management';
import AppearanceManagementDetailContainer from '../../modules/appearance-management-detail';
import CaseApplyContainer from '../../modules/case-apply';
import CaseDetailContainer from '../../modules/case-detail';
import CasesContainer from '../../modules/cases';
import CustomerContainer from '../../modules/customer';
import RolePermissionContainer from '../../modules/role-permission';

// ----- constants -----
const SOCKET_URL = process.env.WEBSOCKET_URL;

/**
 *
 */
class MainFrame extends BaseComponent {
  /**
   *
   */
  constructor(props) {
    super(props);
    this.sidebarRef = React.createRef();
    this.mainRef = React.createRef();
    this.webSocketManager = React.createRef();
    this.state = {
      sidebarClassName: 'sidebar',
      mainClassName: 'main',
      defaultModule: 'cases',
      newSocketMessage: null,
    };
    this.onSocketMessage = this.onSocketMessage.bind(this);
  }

  /**
   * 取得URL
   * @param {*} path
   * @returns
   */
  getUrl(path) {
    return path;
  }

  /**
   *
   */
  componentDidMount() {
    const {userPermissions} = this.props;
    const hasElevatorApplyPermission = userPermissions.some((permission) =>
      permission.children.some((child) => child.moduleName === enumList.moduleEnums.case),
    );

    if (!hasElevatorApplyPermission) {
      const defaultModule = userPermissions[0]?.children[0]?.navigatePath ||
        userPermissions[1]?.children[0]?.navigatePath ||
        'cases';
      this.setState({defaultModule});
    }
  }

  onSocketMessage = (message) => {
    const data = JSON.parse(message);
    console.log('onSocketMessage data:', data);
    // Check if the message is for this user
    console.log('this.props.userId:', this.props.userId);
    if (data.userId && Number(data.userId) === Number(this.props.userId)) {
      console.log('data.event:', data.event);
      if (data.event === 'disable_user' || data.event === 'update_user_role') {
        this.props.userPermissions = [];
        window.location = this.getUrl('/permission-denied');
      } else if (data.event === 'update_user_password') {
        this.props.userPermissions = [];
        window.location = this.getUrl('/notify-password-update');
      } else if (data.event === 'update_role_permission') {
        this.props.userPermissions = [];
        window.location = this.getUrl('/notify-permission-update');
      }
    }

    this.setState({newSocketMessage: data});
  };

  /**
   *
   */
  render() {
    return (
      <div>
        <Routes>
          <Route path="/" element={<Navigate to={this.state.defaultModule} />} />
          <Route path="cases" element={<CasesContainer {...this.props} />} />
          <Route path="cases/:id" element={<CaseDetailContainer />} />
          <Route path="cases-apply" element={<CaseApplyContainer />} />
          <Route path="appearances" element={<AppearanceManagementContainer {...this.props} />} />
          <Route path="appearances-apply" element={<AppearanceManagementDetailContainer isCreate={true} />} />
          <Route path="appearances/:id" element={<AppearanceManagementDetailContainer />} />
          <Route path="customer" element={<CustomerContainer {...this.props} />} />
          <Route path="employee" element={<EmployeeContainer {...this.props} />} />
          <Route path="machine" element={<MachineContainer {...this.props} />} />
          <Route path="machineAssignmentContainer" element={<MachineAssignmentContainer {...this.props} />} />
          <Route path="dispatch-management" element={<DispatchManagementContainer {...this.props} />} />
          <Route path="dispatch-management-calendar" element={<DispatchCalendarContainer {...this.props} />} />
          <Route path="satisfaction-management" element={<SatisfactionManagementContainer {...this.props} />} />
          <Route path="satisfaction-survey" element={<SatisfactionSurveyContainer {...this.props} />} />
          <Route path="satisfaction-management/:caseId" element={<SatisfactionSurveyDetailContainer {...this.props} />} />
          <Route path="role-permission" element={<RolePermissionContainer />} />
          {/* <Route path="resident" element={<ResidentContainer />} /> */}
          <Route path="account-management" element={<AccountManagementContainer />} />
          {/* <Route path="control-code" element={<ControlCodeContainer />} /> */}
        </Routes>
      </div>
    );
  }
}

MainFrame.propTypes = {
  userPermissions: PropTypes.array,
};

MainFrame.defaultProps = {
  userPermissions: [],
};

/**
 *
 */
function mapStateToProps(state) {
  return {
    userPermissions: JSON.parse(state.access.userPermissions),
    userId: state.auth.userId,
  };
}

/**
 *
 */
function mapDispatchToProps(dispatch) {
  return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(MainFrame);
